import api from "./api";

export const searchAddresses = (query, options) =>
  api.get({
    path: "/reference/addresses",
    query,
    options,
  });
